import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useState } from 'react'
import Box from 'src/components/Box/Box'
import Collapsible from 'src/components/Collapsible/Collapsible'
import SvgChevronDown from 'src/components/Svgs/SvgChevronDown'
import SvgChevronRight from 'src/components/Svgs/SvgChevronRight'
import { css } from 'styled-components'

interface AccordionProps {
  className?: string
  topContent: React.ReactElement
  collapsibleContent: React.ReactElement
}

const Accordion: React.FC<AccordionProps> = (props): React.ReactElement => {
  const [isOpen, setOpen] = useState(true)

  return (
    <Box
      className={props.className}
      css={css`
        display: flex;
        flex-direction: row;
        gap: 20px;
      `}
    >
      <div
        onClick={(): void => setOpen(!isOpen)}
        onKeyPress={(): void => setOpen(!isOpen)}
        tabIndex={0}
        role={'button'}
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.cta,
            styleConstants.fontFamilies.medium,
          )};
          height: 16px;
          display: flex;
          align-items: center;
          cursor: pointer;
        `}
      >
        {!isOpen && <SvgChevronRight />}
        {isOpen && <SvgChevronDown />}
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          width: 100%;
          ${isOpen &&
          css`
            gap: 20px;
          `}
        `}
      >
        {props.topContent}
        <Collapsible
          isOpen={isOpen}
          css={css`
            display: flex;
            flex-direction: column;
            gap: 12px;
          `}
        >
          {props.collapsibleContent}
        </Collapsible>
      </div>
    </Box>
  )
}

export default Accordion
